import React from 'react';
import HomeworkBannerBuy from './HomeworkBannerBuy';
import HomeworkHighlights from './HomeworkHighlights';
import HomeworkVideoComponent from './HomeworkVideoComponent';
import HmEventRegistry from '../../model/HmEventRegistry';
import ScrollToTopOnMount from '../../prelogin/src/components/ScrollToTopOnMount';
import PreLoginPage from '../../views/core/PreLoginPage';
import Footer from './Hm_Footer';
import { openPopupWidget } from 'react-calendly';

const CALENDLY_OPEN_KEYS = ["open","opn"]

class HomeworkComponent extends PreLoginPage{
    constructor(props){
        super(props);
        //this.showContactus = null;
    }
    componentDidMount(){
        const me = this;
        //this.showContactus = this.props.showContactus || (()=>{})

        const calOnLoad = this.getQueryParam("cal");

        if(calOnLoad && CALENDLY_OPEN_KEYS.includes(calOnLoad.toLowerCase())){
            let tmp = setTimeout(() => {
                me.calenderlyFn();
                clearTimeout(tmp);
            }, 200);
        }

        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    
    }

    calenderlyFn = () => {
        let url = (window.homework && window.homework.demoURL) ? window.homework.demoURL : '';
        let prefill = "";
        let pageSettings = '';
        let utm="";
        openPopupWidget({ url, prefill, pageSettings, utm })
    }
    
    render(){
        const styles = {
            "float":"left",
            "padding": "10px"
        }

        const styles1 = {
            "float":"right",
            "padding":"10px"
        }

        return(
            <div>
        <ScrollToTopOnMount/>
        
        <header className="homework-header clearfix">
        <div style={styles}>
		  <a href="/"><img src="/img/lumos-logo.png" alt="lumos logo"/></a>
		  </div>
		  <div style={styles1}>
		  <a href="/"><img src="/img/heymath-logo.png" alt="heymath logo"/></a>
		  </div>
        </header>
        <HomeworkBannerBuy demoFn={this.calenderlyFn} name="Home work" classes="bg-grn bg-yellowbg banner-text" text="To achieve your best in the board exams" productBase="cbse" simpleform="true"></HomeworkBannerBuy>
        <HomeworkHighlights></HomeworkHighlights>
        
        <Footer demoFn={this.calenderlyFn}></Footer>
        </div>
        )
    }
}

export default HomeworkComponent;


// WEBPACK FOOTER //
// ./src/vendors/homework/HomeworkComponent.js